var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasSelectedNoGlowState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected State"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 18,
    y: 14.5337,
    width: 66,
    height: 66,
    rx: 15,
    stroke: "#CDD5FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 20,
    y: 16.5337,
    width: 62,
    height: 62,
    rx: 13,
    stroke: "white",
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasSelectedNoGlowState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_selected_no_glow_state.3e5a1358fcc0100be1bff043052064c5.svg";